import { React, useState, useEffect, } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthUser";
import newBooking from '../images/new-booking.png'; // ✅ import image
import axiosClient from "../front/axiosClient";
import { Icons } from "../front/components/Icons";
import StarRating from "./Rating/StarRating";
import { TextAlignEnd } from "lucide-react";

const Dashboard = () => {
    const { user } = useAuth();
    const [todaysBooking, setTodaysBooking] = useState(0);
    const [completedBooking, setCompletedBooking] = useState(0);
    const [completedWalkIn, setCompletedWalkIn] = useState(0);
    const [upcomingBooking, setUpcomingBooking] = useState(0);
    const [todaysEarning, setTodaysEarning] = useState(0);
    const [profileCompition, setprofileCompition] = useState(0);
    const [totalStaff, setTotalStaff] = useState(0);
    const [totalBarbers, setTotalBarbers] = useState(0);
    const [totalCustomers, setTotalCustomers] = useState(0);
    const [rating, setRating] = useState(0);

    useEffect(() => {
        const getTodaysBooking = async () => {
            if (!user?.id) return;

            const response = await axiosClient.get(`/dashboard.php?id=${user.id}`);
            setTodaysBooking(response.data.data.todaysBookingsCount)
            setCompletedBooking(response.data.data.completedBooking)
            setCompletedWalkIn(response.data.data.walkinBooking)
            setUpcomingBooking(response.data.data.upcomingBooking)
            setTodaysEarning(response.data.data.todaysEarnings)
            setprofileCompition(response.data.data.profileCompletion)
            setRating(response.data.data.barberRating)
            setTotalStaff(response.data.data.totalStaff)
            setTotalBarbers(response.data.data.totalBarbers)
            setTotalCustomers(response.data.data.totalCustomers)
        }
        getTodaysBooking();

    }, [user])


    return (
        <div className="dashbaord">
            <div className="grid">
                {profileCompition === 100 ? (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >

                        <p>Welcome, {user?.name}</p>
                        <Link to={`/view-reviews/${user?.id}`} style={{ fontSize: "14px", color: "gray" }}>
                            <div className="card" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                <div className="card-body">
                                    <span>⭐ {rating.rating} ({rating.total_reviews})</span>
                                </div>
                            </div>
                        </Link>
                    </div>
                ) : (
                    <>
                        <Link to="/profile" style={{ fontSize: "20px", color: "gray" }}>
                            <div className="card">
                                <div className="card-body">
                                    <div className="profile-circle" style={{ "--percent": profileCompition }}>
                                        <span className="profile-percent" style={{ "--percent": profileCompition }}>{profileCompition}%</span>
                                    </div>
                                    <p style={{ marginLeft: "80px" }}>Welcome, {user?.name} <br /> Complete your profile to get more bookings and reach more nearby customers.</p>
                                </div>
                            </div>
                        </Link>

                        <Link to={`/view-reviews/${user?.id}`} style={{ fontSize: "14px", color: "gray" }}>
                            <div className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div className="card-body">
                                    <StarRating value={rating.rating} readOnly size={20} />
                                    <span>{rating.rating} ({rating.total_reviews} reviews)</span>
                                </div>
                            </div>

                        </Link>
                    </>

                )}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', justifyContent: 'center', alignItems: 'center' }} >
                    {user?.role === 'admin' && (
                        <>
                            <Link to={`/barbers`} style={{ fontSize: "20px", color: "gray" }}>
                                <div className="card" >
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Icons.Users style={{ fontSize: '24px' }} />
                                        <strong style={{ display: 'block', textAlign: 'right' }}>{totalBarbers}</strong>
                                    </div>
                                    <p>Total Barbers</p>
                                </div>
                            </Link>
                            <Link to="/customers" style={{ fontSize: "20px", color: "gray" }}>
                                <div className="card">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Icons.Users style={{ fontSize: '24px' }} />
                                        <strong style={{ display: 'block', textAlign: 'right' }}>{totalCustomers}</strong>
                                    </div>
                                    <p>Total Customers</p>
                                </div>
                            </Link>
                        </>
                    )}
                    <Link to={`/staff`} style={{ fontSize: "20px", color: "gray" }}>
                        <div className="card" >
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Icons.Users style={{ fontSize: '24px' }} />
                                <strong style={{ display: 'block', textAlign: 'right' }}>{totalStaff}</strong>
                            </div>
                            <p>Total Staff</p>
                        </div>
                    </Link>
                    <Link to="/payments" style={{ fontSize: "20px", color: "gray" }}>
                        <div className="card">
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Icons.Wallet style={{ fontSize: '24px' }} />
                                <strong style={{ display: 'block', textAlign: 'right' }}>{todaysEarning}</strong>
                            </div>
                            <p>Today’s Earnings</p>
                        </div>
                    </Link>
                </div>

                <Link to="/bookings" style={{ fontSize: "20px", color: "gray" }}>
                    <div className="card">
                        {!todaysBooking || todaysBooking.length === 0 ? (
                            <p>No bookings scheduled for today yet.</p>
                        ) : (
                            <>
                                <div className="card-body">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: "20px" }}>
                                        <Icons.colorCalendar style={{ fontSize: '24px' }} />
                                        <p><strong>Today's Bookings</strong></p>
                                    </div>
                                    <strong>{todaysBooking}</strong>
                                </div>
                                <div className="card-body">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: "20px" }}>
                                        <p>Completed</p>
                                        <strong>{completedBooking}</strong>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: "20px" }}>
                                        <p>Upcoming</p>
                                        <strong>{upcomingBooking}</strong>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Link>
                <div className="card">
                    <div className="card-body" style={{ gap: "10px" }}>
                        <Link to={`/booking/${user.id}`} className="btn-primary">
                            Add Walk-in
                        </Link>
                        <div style={{ display: 'flex', alignItems: 'center', gap: "0px" }}>
                            <p>Total Walk-in Completed</p>
                            <strong>{completedWalkIn || 0}</strong>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default Dashboard;